import { render, staticRenderFns } from "./xcDonutCard.vue?vue&type=template&id=ca6667b0&scoped=true"
import script from "./xcDonutCard.vue?vue&type=script&lang=js"
export * from "./xcDonutCard.vue?vue&type=script&lang=js"
import style0 from "./xcDonutCard.vue?vue&type=style&index=0&id=ca6667b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6667b0",
  null
  
)

export default component.exports